import { ToastContainer } from 'react-toastify';

const ToastifyContainer = () => (
  <ToastContainer
    position="top-center"
    autoClose={5000}
    hideProgressBar={true}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss={false}
    draggable
    pauseOnHover
    theme="light"
  />
);

export default ToastifyContainer;
